export default __webpack_public_path__ + "static/media/banner.6eed4a97.jpg";